<template>
  <div class="login">
    <LoginBg>
      <div class="login-content">
        <img src="@/assets/img/login/title.png" alt="logo" />
        <div class="login-form">
          <div class="tabs">
            <div
              class="tabItem pointer"
              :class="{ tabActive: tabVal === item.value }"
              v-for="item in tabsList"
              :key="item.value"
              @click="tabHandle(item.value)"
            >
              {{ item.label }}
            </div>
          </div>
          <CodeLogin
            v-if="tabVal === '1'"
            @active="activeHandle"
            @userAgree="visible = true"
            @privacyAgree="visiblePrivacy = true"
          />
          <PasswordLogin
            v-if="tabVal === '2'"
            @userAgree="visible = true"
            @privacyAgree="visiblePrivacy = true"
          />
          <WechatLogin
            v-if="tabVal === '3'"
            @userAgree="visible = true"
            @privacyAgree="visiblePrivacy = true"
          />
          <QrLogin
            v-if="tabVal === '4'"
            @userAgree="visible = true"
            @privacyAgree="visiblePrivacy = true"
          />
          <div class="footer">
            <a
              href="javascript:"
              @click="toReg"
              v-if="tabVal === '1'"
              class="btn"
              >去注册</a
            >
            <div></div>
            <router-link v-if="tabVal === '1'" to="/forget" class="btn">
              {{ $t('login.forgetPwd') }}</router-link
            >
          </div>
        </div>
      </div>
    </LoginBg>
    <UserAgree v-if="visible" :visible="visible" @close="visible = false" />
    <PrivacyAgree
      v-if="visiblePrivacy"
      :visible="visiblePrivacy"
      @close="visiblePrivacy = false"
    />
    <!-- 账户重新激活确认 -->
    <el-dialog
      title="温馨提示"
      :visible.sync="centerDialogVisible"
      width="500px"
      center
    >
      <span>检测到您在平台有已失效的账户，请确认是否重新激活。</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="$router.push({ name: 'main' })">放弃</el-button>
        <el-button type="primary" @click="activeAccount">确认</el-button>
      </span>
    </el-dialog>
    <el-dialog title="去注册" :visible.sync="regDialogVisible" width="500px">
      <ToReg v-if="regDialogVisible"></ToReg>
    </el-dialog>
  </div>
</template>

<script>
import LoginBg from './components/bg.vue'
import CodeLogin from './components/codeLogin.vue'
import PasswordLogin from './components/passwordLogin.vue'
import QrLogin from './components/qrLogin.vue'
import WechatLogin from './components/wechatLogin.vue'
import { clearLoginInfo } from '@/utils'
import UserAgree from '../components/userAgree'
import PrivacyAgree from '../components/privacyAgree'
import ToReg from './components/toReg.vue'

export default {
  components: {
    LoginBg,
    CodeLogin,
    PasswordLogin,
    QrLogin,
    WechatLogin,
    UserAgree,
    PrivacyAgree,
    ToReg
  },
  data () {
    return {
      visible: false,
      visiblePrivacy: false,
      tabsList: [
        {
          label: '账号登录',
          value: '1'
        }
        // {
        //   label: "账号登录",
        //   value: "2",
        // },
        // {
        //   label: '微信登录',
        //   value: '3'
        // },
        // {
        //   label: '扫码登录',
        //   value: '4'
        // }
      ],
      tabVal: '1',
      centerDialogVisible: false,
      fastDataForm: {
        fastPhone: ''
      },
      regDialogVisible: false
    }
  },
  created () {
    clearLoginInfo()
  },
  mounted () {
    const { tab } = this.$route.query
    tab && this.tabHandle(tab)
  },
  methods: {
    toReg () {
      this.regDialogVisible = true
    },
    tabHandle (val) {
      this.tabVal = val
      console.log(this.tabVal)
    },
    activeHandle (fastDataForm) {
      this.fastDataForm = fastDataForm
      this.centerDialogVisible = true
    },
    // 已注销手机号重新激活
    activeAccount () {
      this.$store.commit('setLoadStatus', true)
      this.$http
        .post('/front/consumer/user/activated', {
          mobile: this.fastDataForm.fastPhone
        })
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.$store.commit('setLoadStatus', false)
            this.$message.success('激活成功,请重新登录')
            setTimeout(() => {
              window.location.reload()
            }, 600)
            this.centerDialogVisible = false
          }
        })
        .catch((err) => {
          this.$store.commit('setLoadStatus', false)
          this.$message.error(err.message)
        })
        .finally(() => {
          this.$store.commit('setLoadStatus', false)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.login {
  .login-content {
    width: 1200px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }
  .login-form {
    margin-top: 36px;
    width: 477px;
    // height: 526px;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 32px 16px;
    background: #fefefe;
    box-sizing: border-box;
    border: 1px solid #ffffff;
    padding: 16px;
  }
  .tabs {
    width: 100%;
    box-sizing: border-box;
    border-width: 0px 0px 1px 0px;
    border-style: solid;
    border-color: #eeeeee;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .tabItem {
    font-family: AlibabaPuHuiTi;
    font-size: 16px;
    text-align: center;
    color: #666666;
    padding: 0 20px 16px;
    position: relative;
    top: 4px;
  }
  .tabActive {
    box-sizing: border-box;
    border-width: 0px 0px 2px 0px;
    border-style: solid;
    border-color: #2a54d1;
    font-family: AlibabaPuHuiTi;
    font-size: 16px;
    font-weight: bold;
    color: #2a54d1;
  }
  .footer {
    width: 100%;
    padding: 0 24px;
    display: flex;
    justify-content: space-between;
    .btn {
      font-family: AlibabaPuHuiTi;
      // font-size: 16px;
      // font-weight: 600;
      text-align: center;
      color: #2a54d1;
    }
  }
  ::v-deep .el-input__inner {
    height: 52px;
    line-height: 52px;
  }
  ::v-deep .el-input__inner:focus {
    border-color: #2a54d1;
  }
  ::v-deep .el-button--text {
    color: #2a54d1;
  }
  ::v-deep .el-button--primary {
    background-color: #2a54d1;
    border-color: #2a54d1;
  }
  ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #2a54d1;
    border-color: #2a54d1;
  }
  ::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #2a54d1;
  }
}
</style>

<style lang="scss">
.login {
  .center {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .m-y-40 {
    margin-top: 40px;
    margin-bottom: 40px;
  }
}
</style>
